import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import apiCalls from "../utils/apiCalls";
import utils from "../utils/utils";
import Loader from "../components/loader";
import ErrorMessage from "../components/errorMessage";
import {withRouter} from "react-router-dom";
import MarketplaceAdminBillPdf from "./marketplaceAdminBillPdf";
import {FormattedMessage, injectIntl} from "react-intl";
import MarketplaceAdminBillPdfDocument from "./marketplaceAdminBillPdfDocument";
import {pdf} from "@react-pdf/renderer";
import { saveAs } from 'file-saver';

const MarketplaceAdminDeliveryDayBill = React.memo(({billId, intl}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bill, setBill] = useState(null);

  useEffect(() => {
    setError(null);
    apiCalls.getBills({
      billId: billId,
    })
      .then((result) => {
        if (result.data.bills && result.data.bills.length) {
          setBill(result.data.bills[0]);
          setLoading(false);
        }
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
        setLoading(false);
      });
  }, []);

  if (!bill || loading) {
    return (
      <Loader show={true}/>
    );
  }

  return (
    <div className="row">
      <div className="col-12">
        <Loader show={loading}/>
        <ErrorMessage error={error}/>

        <button className="btn btn-primary m-b-3" onClick={
          async () => {
            const pdfCopy = utils.getPdfCopy(intl, bill);
            const doc = <MarketplaceAdminBillPdfDocument bill={bill} copy={pdfCopy}/>;
            const asPdf = pdf(); // {} is important, throws without an argument
            asPdf.updateContainer(doc);
            const blob = await asPdf.toBlob();
            saveAs(blob, `${bill.title}.pdf`);
          }
        }>
          <FormattedMessage id={'marketplace.admin.delivery.day.bill.download'}/>
        </button>
        <div className="marketplace-admin__bill">
          <MarketplaceAdminBillPdf bill={bill}/>
        </div>
      </div>
    </div>
  );
});

MarketplaceAdminDeliveryDayBill.propTypes = {
  billId: PropTypes.number.isRequired,
};

MarketplaceAdminDeliveryDayBill.defaultProps = {};

export default injectIntl(withRouter(MarketplaceAdminDeliveryDayBill));